// src/components/About/About.js

import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./About.css";
import doctor from "../../assests/doctor.jpeg";
const handleBookNow = () => {
    const appointmentSection = document.getElementById("appointment");

    if (appointmentSection) {
      appointmentSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };
function About() {
  const aboutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          aboutRef.current.classList.add("show-animation");
        }
      },
      {
        threshold: 0.25
      }
    );

    if (aboutRef.current) {
      observer.observe(aboutRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-section" ref={aboutRef}>

      <div className="about-container">

        {/* LEFT SIDE */}
        <div className="about-left slide-left">

          <div className="logo-card">
            <img
              src={doctor}
              alt="Rootly Homoeopathy"
              className="about-logo"
            />
          </div>

        </div>

        {/* RIGHT SIDE */}
        <div className="about-right slide-right">

          <p className="about-tag">
            ABOUT THE DOCTOR
          </p>

          <h2>
            Dr. Lalitha Maddineni
          </h2>

          <h4>
            BHMS, MD (HOM), M.Sc (Psychology), Certified Nutritionist
          </h4>

          <p className="about-summary">
            5+ years of experience in personalized homeopathic care focused on
            identifying the root cause of illness and guiding patients toward
            long-term wellness through safe, natural and effective treatment.
          </p>

          <ul className="education-list">
            <li>BHMS - Dr. NTR University of Health Sciences</li>
            <li>MD (HOM) - KNR University of Health Sciences</li>
            <li>M.Sc (Psychology) - Andhra University</li>
            <li>Nutrition & Feeding - Banaras Hindu University</li>
          </ul>

          <div className="mini-services">
            <span>Diet Plans</span>
            <span>Mental Health Counseling</span>
            <span>Parenting Assistance</span>
          </div>

          <div className="button-group">

            <Link to="/doctor-details">
              <button className="read-btn">
                Read More
              </button>
            </Link>

            <button className="about-btn" onClick={handleBookNow}>
              Book Consultation
            </button>

          </div>

        </div>

      </div>

    </section>
  );
}

export default About;